/*! Thom Map - v1 - 2017-12-01
 * Copyright (c) 2017 THOM */

(function (factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory)
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'))
  } else {
    factory(jQuery)
  }
})(function ($) {
  'use strict';

  // THOM Menu
  var ThomMap = window.Thommenu || {};

  ThomMap = (function () {
    function ThomMap (element, settings) {
      var _this = this

      /* set default variables */
      _this.defaults = {
        autocomplete: 0,
        backgroundColor: '#fff',
        content: '',
        fitbounds: false,
        geolocation_btn: false,
        getClusterIcons: null,
        getMarkerIcon: null,
        getDistance: null,
        isDett: false,
        maxZoom: 18,
        params: null,
        searchBtn: null,
        searchCallback: null,
        styled: null,
        url: '',
        zoom: 1,
        zoomControl: true,
        zoomControlPosition: google.maps.ControlPosition.RIGHT_BOTTOM,
        zoomToMarker: false
      }

      $.extend(_this, _this.initials);

      _this.$el = $(element);

      _this.s = $.extend({}, _this.defaults, settings);

      // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source
      _this.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

      _this.init();
    }

    return ThomMap;
  })()

  var _bounds = '';
  var elems = '';
  var infowindow;
  var infowindowW;
  var infowindowH;
  var map = null;
  var mapContainer = $('.map-list-content');
  var marker = '';
  var markers = [];
  var markerCluster = null;
  var overlay = '';
  var positions = null;
  var resizing = false;

  /* INITIALIZE PLUGIN */
  ThomMap.prototype.init = function () {
    var _this = this;

    // Set Listeners
    _this.listeners();

    // Create MAP
    _this.create();
  };

  ThomMap.prototype.listeners = function () {
    var _this = this;

    // Window RESIZE
    $(window).on('resize', function () {
      if (!resizing) {
        resizing = true;
        _this.resize();
        setTimeout(function () {
          resizing = false;
        }, 100);
      }
    })

    // Map RESIZE
    google.maps.event.addDomListener(window, 'resize', function () {
      var center = map.getCenter();
      google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
      if (_this.s.fitbounds) {
        map.fitBounds(_bounds);
      }
    })

    // Autocomplete places
    if (_this.s.autocomplete) {
      var input = document.getElementById('Address');
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener('places_changed', function () {
        var places = searchBox.getPlaces();

        if (places != 0 || places != undefined || places != null) {
          _this.s.params.latitude = places[0].geometry.location.lat;
          _this.s.params.longitude = places[0].geometry.location.lng;
        }

        // Ricerco Punti sulla Mappa
        if(_this.s.searchBtn === null){
          _this.searchPoints();
        }
      })
    }

    // Geolocation Btn
    if (_this.s.geolocation_btn) {
      _this.s.geolocation_btn.click(function (e) {
        e.preventDefault();
        _this.geolocate();
      })
    }

    // Geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        _this.s.params.lat = position.coords.latitude;
        _this.s.params.lng = position.coords.longitude;
      })
    }

    if(_this.s.searchBtn !== null){
      _this.s.searchBtn.click(function(e){
        e.preventDefault();
        _this.searchPoints();
      });
    }
  }

  ThomMap.prototype.geolocate = function () {
    var _this = this;

    navigator.geolocation.getCurrentPosition(function (position) {
      _this.geocodeLatLng(position.coords.latitude, position.coords.longitude);
      _this.searchPoints();
    })
  };

  ThomMap.prototype.geocodeLatLng = function (lat, lng) {
    var _this = this;
    var geocoder = new google.maps.Geocoder();

    var latlng = { 
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    }
    geocoder.geocode({ location: latlng }, function (results, status) {
      if (status === 'OK') {
        if (results[0]) {
          $('#Address').val(results[0].formatted_address);
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
    })
  };

  ThomMap.prototype.spinner = function (action) {
    var _this = this;
    if (action === 'show') {
      _this.s.content.find('.map-spinner').fadeIn();
    }

    if (action === 'hide') {
      _this.s.content.find('.map-spinner').fadeOut();
    }
  }

  /* RESIZE */
  ThomMap.prototype.resize = function () {
    var _this = this;
  };

  /* Create The Map */
  ThomMap.prototype.create = function () {
    var _this = this;
    // create map
    map = new google.maps.Map(document.getElementById('map'), {
      center: new google.maps.LatLng(
        _this.s.params.latitude,
        _this.s.params.longitude
      ),
      zoom: _this.s.zoom,
      maxZoom: _this.s.maxZoom,
      backgroundColor: _this.s.backgroundColor,
      zoomControl: _this.s.zoomControl,
      zoomControlOptions: {
        position: _this.s.zoomControlPosition
      },
      panControl: true,
      streetViewControl: false,
      mapTypeControl: false,
      scrollwheel: false,
      fullscreenControl: false
    })

    if (_this.s.styled != null) {
      // add style to map
      map.mapTypes.set('styled_map', _this.s.styled);
      map.setMapTypeId('styled_map');
    }

    // Ricerco Punti sulla Mappa
    if(_this.s.searchBtn === null){
      _this.searchPoints();
    }
  };

  /* Cerco i punti sulla mappa */
  ThomMap.prototype.searchPoints = function () {
    var _this = this;

    _this.spinner('show');

    // Elimino eventuali marker dalla mappa
    _this.markersClear();

    if (markerCluster != null) {
      markerCluster.clearMarkers();
    }

    if (!_this.s.isDett) {
      var data =
        typeof _this.s.params !== 'undefined' && _this.s.params != null
          ? jQuery.param(_this.s.params)
          : {}
      jQuery
        .ajax({
          type: 'GET',
          crossDomain: true,
          url: _this.s.url,
          data: data
        })
        .done(function (response) {
          $('.map-list-wrap').html(response);
          if(_this.s.searchCallback !== null){
            _this.s.searchCallback();
          }
        })
        .fail(function () {
          // console.log( "error" );
        })
        .always(function () {
          _this.spinner('hide');
          _this.mapPositions();
        })
    } else {
      _this.spinner('hide');
      _this.mapPositions();
    }
  }

  /* Get Points positions */
  ThomMap.prototype.mapPositions = function () {
    var _this = this

    positions = []

    if (!_this.s.isDett) {
      elems = $('.map-item')
      var count = elems.length

      if (count != 0) {
        $('.map-msg').fadeOut(300, function () {
          $(this).hide(0)
        })
        mapContainer.fadeIn(300)
        elems.each(function (i) {
          var thiselem = $(this)
          var distance = 0
          var position = {}
          position.lat = parseFloat($(this).attr('lat'))
          position.lng = parseFloat($(this).attr('lng'))
          position.cat = $(this).attr('cat')

          if (_this.s.getDistance != null) {
            navigator.geolocation.getCurrentPosition(
              function (currentposition) {
                var latLngA = new google.maps.LatLng(
                  currentposition.coords.latitude,
                  currentposition.coords.longitude
                )
                var latLngB = new google.maps.LatLng(
                  position.lat,
                  position.lng
                )
                distance = google.maps.geometry.spherical.computeDistanceBetween(
                  latLngA,
                  latLngB
                )
                thiselem
                  .find('.map-item-infowindow .distance')
                  .text((distance / 1000).toFixed(1) + ' km')
                _this.createPosition(thiselem, position, count)
              },
              function () {
                alert('geolocation not supported!!')
              }
            )
          } else {
            _this.createPosition(thiselem, position, count)
          }
        })
      } else {
        mapContainer.fadeOut(300, function () {
          $(this).hide(0)
        })
        $('.map-msg').fadeIn(300)
      }
    } else {
      var position = {}
      position.lat = _this.s.params.latitude
      position.lng = _this.s.params.longitude

      if (_this.s.getMarkerIcon != null) {
        position.ico = _this.s.getMarkerIcon(this).icon
        position.ico_h = _this.s.getMarkerIcon(this).height
      } else {
        position.ico = '';
      }

      positions.push(position)

      _this.markersCreate()
    }
  }

  ThomMap.prototype.createPosition = function (elem, position, count) {
    var _this = this

    if (elem.find('.map-item-infowindow').length) {
      position.text = elem.find('.map-item-infowindow').html()
    }

    if (_this.s.getMarkerIcon != null) {
      position.ico = _this.s.getMarkerIcon(elem).icon
      position.ico_h = _this.s.getMarkerIcon(elem).height
    } else {
      position.ico = '';
    }

    positions.push(position)

    if (positions.length == count) {
      // got to create MAP
      _this.markersCreate()
    }
  }

  // Marker clear
  ThomMap.prototype.markersClear = function () {
    markers.forEach(function (marker) {
      marker.setMap(null)
    })
    $('.iw-wrapper').remove()
    markers = []

    _bounds = new google.maps.LatLngBounds()
  };

  /* Marker create */
  ThomMap.prototype.markersCreate = function () {
    var _this = this

    jQuery.each(
      positions,
      $.proxy(function (index, item) {
        marker = new google.maps.Marker({
          position: { lat: item.lat, lng: item.lng },
          title: '',
          icon: item.ico,
          icon_h: item.ico_h,
          txt: item.text,
          map: map,
          // animation: google.maps.Animation.DROP,
          url:
            'https://www.google.com/maps/dir/?api=1&destination=' +
            item.lat +
            ',' +
            item.lng +
            '',
          category: item.cat
        })

        markers.push(marker)

        _bounds.extend(marker.position)
      }, this)
    )

    // Cluster
    if (_this.s.getClusterIcons != null) {
      // Add a marker clusterer to manage the markers.
      markerCluster = new MarkerClusterer(map, markers, {
        styles: _this.s.getClusterIcons()
      })
    }

    // OVERLAY
    overlay = new google.maps.OverlayView()
    overlay.draw = function () {}
    overlay.setMap(map)

    // FIT MAP TO ITS MARKERS
    if (_this.s.fitbounds) {
      map.fitBounds(_bounds)
    }

    // LISTENERS
    if (!_this.s.isDett) {
      _this.markerListeners()
      _this.itemOpenOverlay()
    }
  }

  /* Marker Listeners */
  ThomMap.prototype.markerListeners = function () {
    var _this = this

    // Click
    $.each(
      markers,
      $.proxy(function (index, item) {
        item.addListener('click', function (e) {
          if (item.txt !== undefined) {
            _this.markerOverlay(item)
          }
        })
      }, this)
    )
  };

  /* Item click Overlay correspondent marker */
  ThomMap.prototype.itemOpenOverlay = function () {
    var _this = this

    $('.map-item').click(function () {
      var id = $(this).index()
      google.maps.event.trigger(markers[id], 'click')
    })
  };

  /* Marker Overlay Infowindow */
  ThomMap.prototype.markerOverlay = function (item) {
    var _this = this

    if ($('.iw-wrapper').length > 0) {
      $('.iw-wrapper').removeClass('in')
      $('.iw-wrapper').remove()
    }

    _this.s.content
      .find('.thom-map')
      .append(
        '<div class="iw-wrapper">' +
          '<div class="iw-close"><span></span></div>' +
          '<div class="iw-content">' +
          item.txt +
          '</div>' +
          '</div>'
      )

    infowindow = $('.iw-wrapper')

    infowindow.find('.iw-close').click(function () {
      infowindow.removeClass('in')
      infowindow.remove()
      elems.removeClass('active')
      if (_this.s.fitbounds) {
        map.fitBounds(_bounds)
      }
    })

    if (_this.s.zoomToMarker) {
      _this.fitToMarker(item)
    } else {
      infowindow.addClass('in')
    }
  }

  // Pan & Zoom map to show all markers
  ThomMap.prototype.fitToMarker = function (item) {
    var _this = this

    var markerBounds = new google.maps.LatLngBounds()

    // Create bounds from marker
    var markerlatlng = item.getPosition()
    markerBounds.extend(markerlatlng)

    // Don't zoom in too far on only one marker
    if (markerBounds.getNorthEast().equals(markerBounds.getSouthWest())) {
      var extendPoint1 = new google.maps.LatLng(
        markerBounds.getNorthEast().lat() + 0.01,
        markerBounds.getNorthEast().lng() + 0.01
      )
      var extendPoint2 = new google.maps.LatLng(
        markerBounds.getNorthEast().lat() - 0.01,
        markerBounds.getNorthEast().lng() - 0.01
      )
      markerBounds.extend(extendPoint1)
      markerBounds.extend(extendPoint2)
    }

    map.fitBounds(markerBounds)

    google.maps.event.addListener(map, 'idle', function () {
      infowindow.addClass('in')
      _this.markerOverlay_reposition(item)
    })
  };

  // Reset infowindow on map pan o zoom
  ThomMap.prototype.markerOverlay_reposition = function (item) {
    if ($('.iw-wrapper').lenght != 0 && $('.iw-wrapper').hasClass('in')) {
      var point = overlay
        .getProjection()
        .fromLatLngToContainerPixel(item.getPosition())
      infowindowW = infowindow.innerWidth()
      infowindowH = infowindow.innerHeight()
      infowindow.css({
        left: point.x - infowindowW / 2 + 'px',
        top: point.y - infowindowH - item.icon_h - 10 + 'px'
      })
    }
  }

  // Filter Marker by category
  ThomMap.prototype.filterMarkers = function (category) {
    for (var i = 0; i < markers.length; i++) {
      marker = markers[i]
      // If is same category or category not picked
      if (
        (typeof marker.category === 'object' &&
          marker.category.indexOf(category) >= 0) ||
        category.length == 0
      ) {
        marker.setVisible(true)
      }
      // Categories don't match
      else {
        marker.setVisible(false)
      }
    }
  }

  ThomMap.prototype.selectAllChecked = function () {
    var _this = this
    var checkedCaregory = []
    var allCheckedElem = document.getElementsByName('filter_checkbox')
    for (var i = 0; i < allCheckedElem.length; i++) {
      if (allCheckedElem[i].checked == true) {
        checkedCaregory.push(allCheckedElem[i].value) // creating array of checked items
      }
    }

    // console.log(checkedCaregory)
    _this.filterChecker(checkedCaregory) // passing to function for updating markers
  };

  ThomMap.prototype.filterChecker = function (categories) {
    var _this = this

    for (var i = 0; i < markers.length; i++) {
      // console.log(i)

      var mymarker = markers[i]

      // console.log(mymarker.category)
      if (jQuery.inArray(mymarker.category, categories) !== -1) {
        mymarker.setVisible(true)
      } else {
        mymarker.setVisible(false)
      }
    }

    for (var n = 0; n < $('.map-item').length; n++) {
      // console.log(i)

      var listmarker = $('.map-item')[n]

      // console.log(mymarker.category)
      if (jQuery.inArray($(listmarker).attr('cat'), categories) !== -1) {
        $(listmarker).show()
      } else {
        $(listmarker).hide()
      }
    }
  }

  // $.fn.thomMap.modules = {}
  $.fn.thomMap = function () {
    var _this = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _this.length,
      i,
      ret
    for (i = 0; i < l; i++) {
      if (typeof opt === 'object' || typeof opt === 'undefined') {
        _this[i].thomMap = new ThomMap(_this[i], opt)
      } else {
        ret = _this[i].thomMap[opt].apply(_this[i].thomMap, args)
      }
      if (typeof ret !== 'undefined') return ret
    }
    return _this
  };
  // })()
})
